import React, { useContext, useState } from "react";
import { AuthContext } from "../../context/auth/AuthContext";
import Error from "../../components/Error";
import Loading from "../../components/Loading";
import { useHistory } from "react-router";
import { UseInstallers } from "../../api/installers/Installers.api";
import { Request } from "../../api/users/Enable.api";
import Warning from "../../components/Warning";

const ListInstallersContainer = ({ children }) => {
  const history = useHistory();
  const { token } = useContext(AuthContext);
  const { content, loading, error, trigger } = UseInstallers(token);
  const [errorEnable, setErrorEnable] = useState(null);
  const [loadingEnable, setLoadingEnable] = useState(false);
  const [id, setId] = useState(0);
  const [warning, serWarning] = useState(false);

  const onCloseSuccesPopupConfirm = () => {
    Request.enableInstaller({
      id_installer: id,
      token,
    })
      .then((data) => onSuccess(data))
      .catch((error) => onFailure(error));
    serWarning(null);
  };

  const onCloseSuccesPopupCancel = () => {
    serWarning(null);
  };

  const onSwitchAction = (id) => {
    serWarning(true);
    setId(id);
  };

  const onSuccess = () => {
    setLoadingEnable(false);
    setErrorEnable(null);
    trigger();
  };

  const onFailure = (error) => {
    setErrorEnable(error);
    setLoadingEnable(false);
  };

  const onViewAllAction = () => {
    history.push("/app/installers");
  };

  return (
    <>
      {error ? <Error message={error} /> : null}
      {errorEnable ? (
        <Error message={errorEnable} onClose={() => setErrorEnable(null)} />
      ) : null}
      {loading || loadingEnable ? <Loading /> : null}
      {warning ? (
        <Warning
          message="Confirm the action?"
          onCloseConfirm={() => onCloseSuccesPopupConfirm()}
          onCloseCancel={() => onCloseSuccesPopupCancel()}
        />
      ) : null}
      {children({ content, onSwitchAction, onViewAllAction })}
    </>
  );
};

export default ListInstallersContainer;
